import Component from './Answer';

export default Component;
